"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParameters = getQueryParameters;
exports.createQueryString = createQueryString;
exports.useURLState = useURLState;
exports.useLocationState = useLocationState;
exports.getLocationState = getLocationState;
var typed_dictionary_1 = require("@sixfold/typed-dictionary");
var typed_primitives_1 = require("@sixfold/typed-primitives");
var query_string_1 = require("query-string");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
function getQueryParameters(search) {
    var parsedQueryString = (0, query_string_1.parse)(search);
    return Object.keys(parsedQueryString).reduce(function (memo, paramKey) {
        var _a, _b, _c;
        var _d;
        var paramValue = parsedQueryString[paramKey];
        if (Array.isArray(paramValue)) {
            return __assign(__assign({}, memo), (_a = {}, _a[paramKey] = (_d = paramValue.shift()) !== null && _d !== void 0 ? _d : undefined, _a));
        }
        if (paramValue === null) {
            return __assign(__assign({}, memo), (_b = {}, _b[paramKey] = undefined, _b));
        }
        return __assign(__assign({}, memo), (_c = {}, _c[paramKey] = paramValue, _c));
    }, {});
}
function createQueryString(queryStringParams) {
    return (0, query_string_1.stringify)(queryStringParams, { arrayFormat: 'comma' });
}
/**
 * Use state (parameters) from location, i.e get the values present, and update them via history.push
 *
 * @param dictionary definition of parameters to extract from query string
 * @returns parsed query string and a function for updating it
 */
function useURLState(dictionary) {
    var history = (0, react_router_dom_1.useHistory)();
    var location = (0, react_router_dom_1.useLocation)();
    var parsedQuery = (0, react_1.useMemo)(function () {
        var params = getQueryParameters(location.search);
        return (0, typed_dictionary_1.Dictionary)(dictionary).parse(params);
    }, [location, dictionary]);
    var updateQuery = (0, react_1.useCallback)(function (value) {
        var actualLocation = history.location;
        history.push(__assign(__assign({}, actualLocation), { search: createQueryString(__assign(__assign({}, getQueryParameters(actualLocation.search)), (0, typed_primitives_1.objectMap)(value, function (key, value) {
                return dictionary[key].serialize(value);
            }))) }));
    }, [history]);
    return (0, react_1.useMemo)(function () { return [parsedQuery, updateQuery]; }, [parsedQuery, updateQuery]);
}
/**
 * Hook for getting a typed value from location state, updates as location updates
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function useLocationState() {
    var location = (0, react_router_dom_1.useLocation)();
    return getLocationState(location);
}
/**
 * Access the location state in a typed way, return value is partial as the state may not include
 * all of the properties
 *
 * @param location location to read the state from
 * @returns Typed state from location
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function getLocationState(location) {
    var _a;
    return ((_a = location.state) !== null && _a !== void 0 ? _a : {});
}
//# sourceMappingURL=use_url_state.js.map